function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoCuBe = function SvgLogoCuBe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "362mm",
    height: "77mm",
    viewBox: "0 0 1026.14 218.27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M262.3,161.3V57h63.48V67.22H273.91v36h42.82v10.1H273.91v37.69h51.87V161.3Z",
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.64,161.3V53.05H359V161.3Z",
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.23,94.51q-16.43,0-16.43,11.46,0,5.28,3.77,7.46T409.76,118q13.41,2.34,19,6.56t5.58,15.83q0,11.61-7.47,17t-21.79,5.43a136,136,0,0,1-22-2.11l-4.52-.75.6-9.8q17.19,2.57,25.93,2.56t13.35-2.79q4.59-2.79,4.6-9.35t-3.92-8.89q-3.93-2.34-17.19-4.45t-18.85-6.18Q377.49,117,377.49,106t7.77-16.29q7.75-5.27,19.37-5.27a158.19,158.19,0,0,1,23.07,2.11l4.22.75-.3,9.65A197.52,197.52,0,0,0,405.23,94.51Z",
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.4,85.92h11.31l18.84,65.58h5l19-65.58h11.3L480.47,194.78H469.16L479,161.3H467.81Z",
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.3,84.41a129.64,129.64,0,0,1,16.88,1.81l3.62.45-.45,9.2a175.44,175.44,0,0,0-17.79-1.36q-12.82,0-17.42,6.11t-4.6,22.61q0,16.52,4.3,23t17.87,6.48l17.79-1.36.45,9.35a154.5,154.5,0,0,1-21,2.11q-17.64,0-24.35-9t-6.71-30.54q0-21.48,7.24-30.15T553.3,84.41Z",
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.08,108.68v38.6q.45,5.58,8.74,6.64l-.45,8.89q-11.91,0-17.94-6a66.35,66.35,0,0,1-27.14,6q-10.41,0-15.83-5.88T589,140q0-11,5.58-16.2t17.49-6.41l23.67-2.26v-6.49q0-7.68-3.32-11t-9-3.32a215.59,215.59,0,0,0-25,1.51l-4.68.45-.45-8.6a152,152,0,0,1,29.4-3.31q12.83,0,18.62,5.88T647.08,108.68Zm-46.44,30.76q0,13.88,11.46,13.87a61,61,0,0,0,20.2-3.46l3.47-1.21V123.76l-22.31,2.11q-6.8.6-9.81,3.92T600.64,139.44Z",
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.55,159.65a141.24,141.24,0,0,1-27.9,3.16q-12.36,0-20-3.39a25,25,0,0,1-11.76-10.55,48.8,48.8,0,0,1-5.73-16.44,140.35,140.35,0,0,1-1.59-23.14A143.32,143.32,0,0,1,702.19,86a49.65,49.65,0,0,1,5.73-16.66A24.52,24.52,0,0,1,719.6,58.78q7.54-3.31,19.6-3.32a144.88,144.88,0,0,1,28.35,3.32l-.45,9.8A156.71,156.71,0,0,0,740,65.86q-16.59,0-21.94,9.88t-5.36,33.7a149.63,149.63,0,0,0,1,19.15,42.22,42.22,0,0,0,3.85,13,17,17,0,0,0,8.37,8.29q5.5,2.49,16.13,2.49a138.91,138.91,0,0,0,25.11-2.72Z",
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.63,85.92h11.31V161.3H831.63V156q-11.31,6.78-22.32,6.78-15.37,0-20.43-8t-5-29.55V85.92h11.31v39.2q0,16.44,2.86,22t13,5.58a37.6,37.6,0,0,0,10.1-1.43,46.94,46.94,0,0,0,7.84-2.79l2.72-1.36Z",
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.61,57h37.84q15.52,0,23.3,6.4t7.76,20.13q0,9.81-3.39,15.31a23.06,23.06,0,0,1-10,8.67q16.59,5.73,16.59,24.57,0,15.69-8.29,22.47t-24,6.78h-39.8ZM904,67.22H878.22v36h26.83q9.66,0,14.1-4.6t4.45-13.87q0-9.29-4.75-13.42T904,67.22Zm1.21,46.14h-27v37.69H906q10.24,0,15.6-4.29t5.36-15.16a19.56,19.56,0,0,0-2.19-9.65,12.73,12.73,0,0,0-5.8-5.58A32.85,32.85,0,0,0,905.21,113.36Z",
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.49,161.3V57H1023V67.22H971.1v36h42.82v10.1H971.1v37.69H1023V161.3Z",
    style: {
      fill: "#347190"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.21,215.43a24.24,24.24,0,0,1-9.82-2.57L13.31,169.34c-5.31-3.06-11.5-9.27-11.5-16.71v-87c0-7.56,6-13.73,11.22-16.71L90.15,5.39a21.25,21.25,0,0,1,9.06-2.56,18.16,18.16,0,0,1,9.43,2.58l75,43.52c7.81,4.51,7.81,13.69,7.81,16.71v87c0,8-2.72,13.61-8.09,16.71l-73.94,43.5A20.87,20.87,0,0,1,99.21,215.43Z",
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.21,9.55a15.27,15.27,0,0,0-5.73,1.68L16.35,54.76C12.47,57,8.52,61.24,8.52,65.64v87c0,4.29,4.08,8.56,8.13,10.89L92.73,207a18.13,18.13,0,0,0,6.48,1.69A14.24,14.24,0,0,0,106,207L180,163.53c2.06-1.18,4.76-3.58,4.76-10.9v-87c0-5.76-1.38-9.11-4.46-10.89h0l-75-43.53A11.61,11.61,0,0,0,99.21,9.55Z",
    style: {
      fill: "#daeff8"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.61,
    y: 112.47,
    width: 73.35,
    height: 6.67,
    rx: 3.12,
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.61,
    y: 129.14,
    width: 63.35,
    height: 6.67,
    rx: 3.12,
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.61,
    y: 145.81,
    width: 53.35,
    height: 6.67,
    rx: 3.12,
    style: {
      fill: "#347190"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 134.97,
    y: 65.79,
    width: 6.67,
    height: 86.69,
    rx: 3.12,
    style: {
      fill: "#347190"
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoCuBe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_CuBE.f3c0c9fe.svg";
export { ForwardRef as ReactComponent };